import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider, ClerkLoading, ClerkLoaded } from '@clerk/clerk-react';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/data';

const clerkPubkey = 'pk_test_YWxsb3dpbmctcGxhdHlwdXMtMTIuY2xlcmsuYWNjb3VudHMuZGV2JA';

const root = ReactDOM.createRoot(document.getElementById('root'));

const LoadingFallback = () => (
  <div className="loading max-w-7xl mx-auto flex items-center justify-center h-screen text-6xl">
    <l-zoomies
      size="80"
      stroke="5"
      bg-opacity="0.1"
      speed="1.4"
      color="black"
    ></l-zoomies>
  </div>
);

root.render(
  <ClerkProvider publishableKey={clerkPubkey} afterSignInUrl="/dashboard" afterSignUpUrl="/dashboard">
    <AuthProvider>
      <React.StrictMode>
        <BrowserRouter>
          <ClerkLoading>
            <LoadingFallback />
          </ClerkLoading>
          <ClerkLoaded>
            <App />
          </ClerkLoaded>
        </BrowserRouter>
      </React.StrictMode>
    </AuthProvider>
  </ClerkProvider>
);

reportWebVitals(console.log);
